import { ACCOUNTS_FEATURE_FLAG_TOGGLES } from "../constants";

export function isAccountFeatureToggle(
  toggle: string
): toggle is typeof ACCOUNTS_FEATURE_FLAG_TOGGLES[number] {
  const accountToggles: readonly string[] = ACCOUNTS_FEATURE_FLAG_TOGGLES;
  return accountToggles.includes(toggle);
}
